import React from 'react';

import { Paper, makeStyles} from '@material-ui/core';
import { Link } from '@portal/arq-portal-core';

import { TabProps } from '../shared/TabProps';
import { ResultadoVacio } from './ResultadoVacio';
import { withPagination } from './withPagination';

const useStyles = makeStyles({
    tabContent: {
        padding: '15px 60px',
        '@media screen and (max-width: 959px)': {
            padding: '15px 20px',
        },
    },
    busquedaItem: {
        borderBottom: "2px dotted #d6d8d8", 
        padding: "28px 0px",
        '& h4': {
            color: '#DC0028',
            fontSize: '16px',
            marginTop: '0px',           
            marginBottom: '15px',
        },
        '& p': {
            color: '#606060',
            fontSize: '14px',
            marginBlockStart: '0em',
            marginBlockEnd: '8px',
            
        },
    },
    enlace: {
        color: '#DC0028',
        textDecoration: 'underline',  
        fontSize: '14px',
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }
});

const TabMenu = ({ texto, resultados }: TabProps) => {
    const clases = useStyles();

    var reg = new RegExp(texto, 'gi');
  
    return (
        <div
        role="tabpanel"
        className={clases.tabContent}
        id='busqueda-tabpanel-1'
        aria-labelledby='busqueda-tab-1'
        >
            {resultados.length > 0 ?
                <Paper elevation={0} square>

                    {resultados.map((menu: any, indx:number) => {
                        return <div className={clases.busquedaItem}>
                            <Link to={menu.url ?? "/"} key={indx}>
                                <div>
                                    <h4>{menu.titulo}</h4>
                                    <p dangerouslySetInnerHTML={{ __html: menu.path.replace(reg, function (str:string) { return '<b style="background-color: #FCFA51">' + str + '</b>' }) ?? "" }}></p>
                                    <a className={clases.enlace} dangerouslySetInnerHTML={{ __html: `${window.location.origin}${menu.url}`.replace(reg, function (str:string) { return '<b style="background-color: #FCFA51">' + str + '</b>' }) ?? "" }}></a>
                                </div>
                            </Link>
                        </div>
                    })}
                </Paper> :
                <ResultadoVacio />
            }
        </div>
    );
  }

export const TabMenuPaginado = withPagination(TabMenu, 10);
